/**
 * 封装 axios 的 interceptor
 */
//import Vue from 'vue'
import axios from 'axios'


import setting from '@/config/setting'



let loadingInstance

// 创建axios实例

const instance = axios.create({
    baseURL: setting.baseURL,
    timeout: setting.requestTimeout,
    headers: {
      'Content-Type': setting.contentType,
    },
    // `transformRequest` 允许在向服务器发送前，修改请求数据
    transformRequest: [
      function(data) {
        // 对 data 进行任意转换处理
        return data;
      }
    ],
    // `transformResponse` 在传递给 then/catch 前，允许修改响应数据
    transformResponse: [
      function(data) {
        // 对 data 进行任意转换处理
        return JSON.parse(data);
      }
    ]
});


  
/* 实例添加请求拦截器 */
instance.interceptors.request.use(
    (config) => {
   

 
      return config
    },
    (error) => {
      // 对请求错误做处理...
      return Promise.reject(error)
    }
)

/* 实例添加响应拦截器 */
instance.interceptors.response.use((res) => {

      // 对响应数据做处理，以下根据实际数据结构改动！！...

    if (loadingInstance) loadingInstance.close()
   

    return res;
}, (error) => {

    if (loadingInstance) loadingInstance.close();

    return Promise.reject(error);
});


export default instance
